<template>
  <div class="financial-tab--financial-credit-cards-tab">

    <div class="form-row">
      <div class="form-group col-md-5">
        <form autocomplete="off">
          <b-card bg-variant="light">
            <b-form-group
              label="Select a card to edit or add a new one"
              label-class="pt-0 text-dark"
              class="mb-0"
            >
              <div id="buttonHeader" class="buttons-panel">
                <b-button
                  type="button"
                  @click="onFormCancel"
                  size="sm"
                >Clear</b-button>
                <b-button
                  type="button"
                  variant="primary"
                  @click="onSubmit"
                  size="sm"
                  :disabled="isSaving"
                ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
              </div>

              <div class="col-md-12">
                <!-- TYPE -->
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <b-form-group class="required" label="Type">
                      <select
                        v-model="creditCard.cardType"
                        class="custom-select"
                        :class="{ 'is-invalid': $v.creditCard.cardType.$error }"
                        @blur="$v.creditCard.cardType.$touch()"
                      >
                        <option
                          v-for="(select, index) in sortSelect(creditCardTypes)"
                          :key="index"
                          :value="select.name"
                        >{{ select.name }}</option>
                      </select>
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.cardType.required">Type is required</div>
                      </div>
                    </b-form-group>
                  </div>
                  <!-- ACCOUNT NUMBER -->
                  <div class="form-group col-md-5">
                      <b-form-group class="required" label="Account #">
                      <input
                        type="text"
                        class="form-control"
                        id="account-number-input"
                        v-model="creditCard.accountNumber"
                        :class="{ 'is-invalid': $v.creditCard.accountNumber.$error }"
                        @blur="$v.creditCard.accountNumber.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.accountNumber.required">Account # is required</div>
                        <div v-if="!$v.creditCard.accountNumber.accountNumberLengthValidator">Account # is too short</div>
                        <div v-if="!$v.creditCard.accountNumber.accountNumberValidator">Account # is invalid</div>
                      </div>
                      </b-form-group>
                  </div>
                </div>

                <div class="form-row">

                  <!-- CVC NUMBER -->
                  <div class="form-group col-md-4">
                    <b-form-group class="required" label="CVC #">
                      <input
                        type="text"
                        class="form-control"
                        id="cvc-number-input"
                        v-model="creditCard.cvcCode"
                        :class="{ 'is-invalid': $v.creditCard.cvcCode.$error }"
                        @blur="$v.creditCard.cvcCode.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.cvcCode.required">Required</div>
                        <div v-if="!$v.creditCard.cvcCode.minLength">Too short</div>
                        <div v-if="!$v.creditCard.cvcCode.maxLength">Too long</div>
                        <div v-if="!$v.creditCard.cvcCode.integer">Only digits</div>
                      </div>
                    </b-form-group>
                  </div>

                  <!-- EXP MONTH -->
                  <div class="form-group col-md-3">
                    <b-form-group class="required" label="Exp Month">
                      <select
                        v-model="creditCard.expMonth"
                        class="custom-select"
                        :class="{ 'is-invalid': $v.creditCard.expMonth.$error }"
                        @blur="$v.creditCard.expMonth.$touch()"
                      >
                        <option
                          v-for="(select, index) in sortSelect(expMonths)"
                          :key="index"
                          :value="select.id"
                        >{{ select.name }}</option>
                      </select>
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.expMonth.required">Required</div>
                      </div>
                    </b-form-group>
                  </div>

                  <!-- EXP YEAR -->
                  <div class="form-group col-md-3">
                    <b-form-group class="required" label="Exp Year">
                      <select
                        v-model="creditCard.expYear"
                        class="custom-select"
                        :class="{ 'is-invalid': $v.creditCard.expYear.$error }"
                        @blur="$v.creditCard.expYear.$touch()"
                      >
                        <option
                          v-for="(select, index) in sortSelect(expYears)"
                          :key="index"
                          :value="select.id"
                        >{{ select.name }}</option>
                      </select>
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.expYear.required">Required</div>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <!-- NAME ON CARD -->
                <div class="form-row">
                  <div class="form-group col-md-10">
                    <b-form-group class="required" label="Name on Card">
                      <input
                        type="text"
                        class="form-control"
                        id="mame-on-card-input"
                        v-model="creditCard.nameOnCard"
                        :class="{ 'is-invalid': $v.creditCard.nameOnCard.$error }"
                        @blur="$v.creditCard.nameOnCard.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.nameOnCard.required">Name is required</div>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <!-- ADDRESS -->
                <div class="form-row">
                  <div class="form-group col-md-10">
                    <b-form-group class="required" label="Address">
                      <input
                        type="text"
                        class="form-control"
                        id="address-input"
                        v-model="creditCard.address"
                        :class="{ 'is-invalid': $v.creditCard.address.$error }"
                        @blur="$v.creditCard.address.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.address.required">Address is required</div>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-row">
                  <!-- CITY -->
                  <div class="form-group col-md-5">
                    <b-form-group class="required" label="City">
                      <input
                        type="text"
                        class="form-control"
                        id="city-input"
                        v-model="creditCard.city"
                        :class="{ 'is-invalid': $v.creditCard.city.$error }"
                        @blur="$v.creditCard.city.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.city.required">City is required</div>
                      </div>
                    </b-form-group>
                  </div>

                  <!-- STATE/PROVINCE -->
                  <div class="form-group col-md-5">
                    <b-form-group class="required" label="State / Province">
                      <input
                        type="text"
                        class="form-control"
                        id="state-province-input"
                        v-model="creditCard.state"
                        :class="{ 'is-invalid': $v.creditCard.state.$error }"
                        @blur="$v.creditCard.state.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.state.required">State/Province is required</div>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-row">
                  <!-- POSTAL CODE -->
                  <div class="form-group col-md-5">
                    <b-form-group class="required" label="Postal Code">
                      <input
                        type="text"
                        class="form-control"
                        id="postal-code-input"
                        v-model="creditCard.postalCode"
                        :class="{ 'is-invalid': $v.creditCard.postalCode.$error }"
                        @blur="$v.creditCard.postalCode.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.postalCode.required">Postal code is required</div>
                      </div>
                    </b-form-group>
                  </div>

                  <!-- COUNTRY -->
                  <div class="form-group col-md-5">
                    <b-form-group class="required" label="Country">
                      <input
                        type="text"
                        class="form-control"
                        id="country-input"
                        v-model="creditCard.country"
                        :class="{ 'is-invalid': $v.creditCard.country.$error }"
                        @blur="$v.creditCard.country.$touch()"
                      >
                      <div class="invalid-feedback">
                        <div v-if="!$v.creditCard.country.required">Country is required</div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <required-descriptor />

            </b-form-group>
          </b-card>
        </form>
      </div>
      <div class="form-group offset-md-1 col-md-5">
        <b-row class="search">
          <b-col cols="4">
            <b-form-input
              size="sm"
              class="mr-sm-2 search-input"
              placeholder="Search Last 4 Digits"
              left
              @input="onSearch"
              v-model="searchQuery"
            ></b-form-input>
          </b-col>
        </b-row>

        <cards-grid
          :items="creditCardList"
          :onEdit="onEdit"
          :onDelete="onDelete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { createScroll, destroyScroll, isElementInView } from '@/shared/scroll'
import { initializeYears } from '@/shared/helpers';
import { EXP_MONTH, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';

import CardsGrid from './components/CardsGrid';

import {
  required,
  minLength,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators';
import {
  accountNumberValidator,
  accountNumberLengthValidator,
} from '@/shared/validators';

export default {
  name: 'FinancialCreditCardsTab',
  components: {
    CardsGrid,
  },
  data() {
    return {
      searchQuery: '',
      creditCard: {},
      isSaving:false,
      expMonths: EXP_MONTH,
      expYears: [],
      buttonsHeaderVisible: true,
    };
  },
  validations: {
    creditCard: {
      cardType: { required },
      accountNumber: { required, accountNumberValidator, accountNumberLengthValidator },
      cvcCode: { required, minLength: minLength(3), maxLength: maxLength(4), numeric },
      expMonth: { required },
      expYear: { required },
      nameOnCard: { required },
      address: { required },
      city: { required },
      state: { required },
      postalCode: { required },
      country: { required },
    },
  },
  computed: {
    /*...mapGetters('creditCards', [
      'creditCardTypes',
      'creditCardList',
      'currentCreditCard',
    ]),*/
    ...mapGetters('creditCards', [
      'creditCardTypes',
      'creditCardList'
    ]),
  },
  methods: {
    ...mapActions('creditCards', [
      'getCreditCardTypes',
      'getAllCreditCards',
      /*'addNewCreditCard',
      'editCreditCard',
      'deleteCreditCard',*/
      'getCreditCardById',
      'clearCreditCardForm',
      'manage',
      'deleteRecord',
    ]),
    onSubmit: async function(e) {
      e.preventDefault();

      this.$v.creditCard.$touch();
      if (this.$v.creditCard.$invalid) {
        return;
      }

      this.creditCard.accountLast4 = this.creditCard.accountNumber
        .replace(/\D/g, '')
        .substr(-4);
      try {
        this.isSaving = true;
        /*if (!this.creditCard.id) {
          await this.addNewCreditCard(this.creditCard);
          this.clearForm();
          this.getCreditCardList();
        } else {
          await this.editCreditCard(this.creditCard);
          this.clearForm();
          this.getCreditCardList();
        }*/

        await this.manage(this.creditCard);
        this.clearForm();
        this.getCreditCardList();

        this.isSaving = false;
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    clearForm: async function() {
      this.creditCard = await this.clearCreditCardForm();
      this.$v.creditCard.$reset();
      this.initializeCard();
    },
    getCreditCardList() {
      this.searchQuery = this.searchQuery.replace(/#/g, '');
      const payload = {
        accountId: this.$route.params.id,
        searchQuery: this.searchQuery,
      };
      this.getAllCreditCards(payload);
    },
    onFormCancel: function(e) {
      e.preventDefault();
      this.clearForm();
    },
    async onEdit(value) {
      this.creditCard = await this.getCreditCardById(value.id);
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete "${item.cardType}" credit card with last 4 numbers: "${item.accountLast4}"?`});
      if (deleteConfirmed) {
        /*await this.deleteCreditCard(item.id);*/
        await this.deleteRecord(item.id);
        await this.clearForm();
        this.getCreditCardList();
      }
    },
    handleScroll() {
      this.buttonsHeaderVisible = isElementInView(document.getElementById('buttonHeader'));
    },
    initializeCard() {
      this.creditCard.accountId = this.$route.params.id;
      this.creditCard.id = 0;
    },
    onSearch: debounce(function() {
      this.getCreditCardList();
    }, SEARCH_DEBOUNCE_TIME),
  },
  async created() {
    await this.clearForm();
    this.initializeCard();
    this.expYears = initializeYears();
    createScroll(this);
  },
  async mounted() {
    this.getCreditCardList();
    this.getCreditCardTypes();
  },
  destroyed() {
    destroyScroll(this);
  },
};
</script>

<style lang="scss">
.financial-tab--financial-credit-cards-tab {
  .buttons-panel {
    margin-top: 10px;
  }
  .buttons-panel {
    text-align: right;
    .btn {
      margin-left: 10px;
    }
  }
  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 45%;
    z-index: 7;
  }

  .cancelButton {
    margin-right: 10px;
  }
}
</style>
